import { Container, Content, SectionFilterPonto, HeaderPonto, HeaderPontoSecond, SectionPanel, HalfPanel,SectionTablePonto} from './styles';
import { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import message from "../../services/message";
import moment from 'moment';
import { useHistory } from 'react-router-dom';

export function Home(){
  const [entradas, setEntradas] : any = useState({})
  const [saidas, setSaidas] : any = useState({})
  const history = useHistory();

  useEffect(() => {
    getEntradas()
    getSaidas()
  },[])

  async function getEntradas(){
    try{
      let response : any =  await api.get(`/entrada?paginate=true&page=1&items=90&de=${moment().startOf('month').format('YYYY-MM-DD')}&ate=${moment().endOf('month').format('YYYY-MM-DD')}`)
      setEntradas(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function getSaidas(){
    try{
      let response : any =  await api.get(`/saida?paginate=true&page=1&items=90&de=${moment().startOf('month').format('YYYY-MM-DD')}&ate=${moment().endOf('month').format('YYYY-MM-DD')}`)
      setSaidas(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  return (
    <Container>
        
      
      <SectionPanel>
        <HalfPanel>
          <HeaderPontoSecond>
            <h1 className="titlePonto">Entradas</h1>
            <button
              style={{ margin: "0px", width: "200px", letterSpacing: "1px",verticalAlign:'middle', height:'35px' }}
              className="btn btn-primary"
              onClick={() =>  history.push('/entradas/relatorio')}
            > 
              Relatório de Entradas
              <i className="fa-solid fa-plus"></i>
            </button>
            
          </HeaderPontoSecond>
          <SectionTablePonto>
            <table className="default">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Cliente</th>
                  <th>Valor Liquido</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
              { entradas && entradas.data && entradas.data.length > 0 &&
              entradas.data.map((row:any, key:any) =>(
                <tr key={''}>
                  <td>{row.data}</td>
                  <td>{row?.cliente?.nome}</td>
                  <td>{parseFloat(row.valorLiquido).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}</td>
                  <td style={{textTransform:'uppercase'}}>{row.statusPagamento}</td>
                </tr>
                ))
              }
              </tbody>
            </table>
          </SectionTablePonto>
        </HalfPanel>
        <HalfPanel>
          <HeaderPontoSecond>
            <h1 className="titlePonto">Saídas</h1>
            <button
              style={{ margin: "0px", width: "200px", letterSpacing: "1px",verticalAlign:'middle', height:'35px' }}
              className="btn btn-primary"
              onClick={() =>  history.push('/saidas/relatorio')}
            > 
              Relatório de Saídas
              <i className="fa-solid fa-plus"></i>
            </button>
          </HeaderPontoSecond>
          <SectionTablePonto>
            <table className="default">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Despesa/Colaborador</th>
                  <th>Valor</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                { saidas && saidas.data && saidas.data.length > 0 &&
                saidas.data.map((row:any, key:any) =>(
                  <tr key={key}>
                    <td style={{width:'120px'}}>{row.data}</td>
    
                    <td>{row?.colaborador?.nome} {row?.despesa?.nome}</td>
  
                    <td>{parseFloat(row.valor).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </td>
                    <td style={{textTransform:'uppercase'}}>{row.statusPagamento}</td>

                  </tr>
                ))
              }
              </tbody>
            </table>
          </SectionTablePonto>
        </HalfPanel>
        
      </SectionPanel>
      
    </Container>
  );
}